<template>
  <v-app>
    <v-main>
      <div>
        <div v-if="loading" class="loader-overlay" >
          <v-container fill-height fluid class="d-flex align-center justify-center">
            <div class="containerss">
              <div class="loader"></div>
              <div class="loader"></div>
              <div class="loader"></div>
              <div class="loader"></div>
              <div class="loader"></div>
            </div>
          </v-container>
        </div>

        <div v-else>
          <router-view />
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .text-h1,
  .text-h2,
  .text-h3,
  .text-h4,
  .text-h5,
  .text-h6,
  .text-headline,
  .text-title,
  .text-subtitle-1,
  .text-subtitle-2,
  .text-body-1,
  .text-body-2,
  .text-button,
  .text-caption,
  .text-overline {
    font-family: "OpenSans" !important;
  }
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
//  background-color: rgba(255, 255, 255, 0.9);
background-color: rgb(5, 23, 56);
  z-index: 9999;
}

.containerss {
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 100vh;
}

.loader {
  width: 10px;
  height: 30px;
  left: var(--left);
  border-radius: 10px 50px;
  box-shadow: 0px 0px 5px black;
  animation: dominos 1s ease infinite;
}

.loader:nth-child(1) {
  --left: 80px;
  animation-delay: 0.325s;
  background-color: red;
}

.loader:nth-child(3) {
  left: 60px;
  animation-delay: 0.625s;
  background-color: blue;
}

.loader:nth-child(5) {
  animation-delay: 0.865s;
  left: 40px;
  background-color: green;
}

.loader:nth-child(2) {
  --left: 70px;
  animation-delay: 0.5s;
  background-color: yellow;
}

.loader:nth-child(4) {
  animation-delay: 0.74s;
  left: 50px;
  background-color: orange;
}

@keyframes dominos {
  50% {
    opacity: 0.7;
  }

  75% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }

  80% {
    opacity: 1;
  }
}
</style>

<script>
export default {
  data() {
    return {
      loading: true,
    };
  },

  mounted() {
    // simulate a delay of 2 seconds to demonstrate the loader
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
};
</script>
